module.exports = __webpack_public_path__ + "img/io.dacfa8ad.svg";